import { Check } from '@mui/icons-material';
import {
    AlertColor,
    Box,
    Button,
    Typography
} from '@mui/material';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { ShareFile, ShareFileCreate } from "../../../../model/SharedFileModel";
import { GetOneItem } from '../../../../services/Item/ItemServicesGet';
import { GetOrganizationUserName } from '../../../../services/OrganizationServices';
import {
    GetSharedFileInformation,
    SaveSharedFileInformation,
    UpdateSharedFileInformation
} from "../../../../services/SharedFileServices";
import { ShareFileCompDefault } from './ShareFileCompDefault';
import { ShareFileWatermark } from './ShareFileWatermark';
import { validateEmail, validEmail } from '../../../WizardFree/validators/stepTwoValidation';
import KeydriveSnackbar from '../../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar';


export interface ShareFileConfig{
    itemId:string;
}

export interface ShareFileParams{
    saveOkMetod: () => void
    shareFileConfig:ShareFileConfig;
    onEditWatermark?: () => void;
    watermarkEnabled?: boolean;
    setWatermarkEnabled?: React.Dispatch<React.SetStateAction<boolean>>;
    setShowSnackBar: (set: boolean) => void;
    setMessageSnackbar: (set: string) => void;
    setAlertColor: (set: AlertColor) => void;
    onClose?: () => void;
}

export interface ISharePanelState {
    default: boolean;
    waterMark: boolean;
}

export interface IWatermarkOptions {
    orientation: string;
    text: string;
    needWm: boolean;
}

const ShareFileComp = (props: ShareFileParams) => {
    const { t } = useTranslation();
    const [dontExpire, setDontExpire] = useState<boolean>(false);
    const [hasWatermark, setHasWatermark] = useState<boolean>(true);
    const [isCalendar, setIsCalendar] = useState<boolean>(false);
    const [selectedDate, setSelectedDate] = React.useState<Date | undefined>(new Date());
    const [isAcess, setIsAcess] = useState<boolean>(false);
    const [acessCount, setAcessCount] = useState<string>("1");
    const { nameOrg } = useParams();
    const [fileExtension, setFileExtension] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    
    const [shareFileConfig, setShareFileConfig] = useState<ShareFile|undefined>(undefined);
    const [waitConsult, setWaitConsult] = useState<boolean>(false);
    const [waitSave, setWaitSave] = useState<boolean>(false);

    const [snackMessage, setSnackMesssage] = useState<string>("");
    const [isOpenSnack, setIsOpenSnack] = useState<boolean>(false);
    const [snackSeverity, setSnackSeverity] = useState<AlertColor>("success");

    const [usersMenu, setUsersMenu] = useState<string[]>([]);
    const [emails, setEmails] = useState<string[]>([]);
    const [sharePanelState, setSharePanelState] = useState<ISharePanelState>({
        default: true,
        waterMark: false
    });
    const [watermarkOptions, setWatermarkOptions] = useState<IWatermarkOptions>({
        orientation: "",
        text: "",
        needWm: false
    });

    const [waterMark, setRadioWatermark] = React.useState("");

    const handleChangeWater = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioWatermark(event.target.value);
        setWatermarkOptions({
            ...watermarkOptions,
            needWm: event.target.value == "2"
        });
    };

    useEffect(() => {
        GetOneItem(props.shareFileConfig.itemId)
        .then(data => {
            setFileExtension(data?.extension!);
            setFileName(data?.name!);
        })
        .catch(err => {
            props.setAlertColor("error");
            props.setMessageSnackbar(err.response.data);
            props.setShowSnackBar(true);   
            setSnackSeverity("error");
            setSnackMesssage(err.response.data);
            setIsOpenSnack(true);
        })
        .finally(() => {

        })
    }, [props.shareFileConfig.itemId])

    useEffect(() => {
        GetSharedFileInformation(props.shareFileConfig.itemId)
        .then((response) =>{
            if(response != null || response != undefined)
            {
                setShareFileConfig(response);
                if (response.isFolderHighSensitivity) {
                    props.setAlertColor("warning");
                    props.setMessageSnackbar(t("FolderWithHighSensitivitySharedWarning.message"));
                    props.setShowSnackBar(true);
                    setSnackSeverity("warning");
                    setSnackMesssage(t("FolderWithHighSensitivitySharedWarning.message"));
                    setIsOpenSnack(true);
                } else if (response.isWorkspaceAlwaysInWaterMark ) {
                    props.setAlertColor("warning");
                    props.setMessageSnackbar(t("WorkspaceAlwaysWithWaterMarkWarning.message"));
                    props.setShowSnackBar(true);
                    setSnackSeverity("warning");
                    setSnackMesssage(t("WorkspaceAlwaysWithWaterMarkWarning.message"));
                    setIsOpenSnack(true);
                }
            }
            else
            {
                var sharedResponse: ShareFile = response;
                var shareFileNull: ShareFile = {
                    isWorkspaceAlwaysInWaterMark: sharedResponse.isWorkspaceAlwaysInWaterMark,
                    isFolderHighSensitivity: sharedResponse?.isFolderHighSensitivity!
                }
                if (sharedResponse.isFolderHighSensitivity) {
                    props.setAlertColor("warning");
                    props.setMessageSnackbar(t("FolderWithHighSensitivitySharedWarning.message"));
                    props.setShowSnackBar(true);
                    setSnackSeverity("warning");
                    setSnackMesssage(t("FolderWithHighSensitivitySharedWarning.message"));
                    setIsOpenSnack(true);
                } else if (sharedResponse.isWorkspaceAlwaysInWaterMark ) {
                    props.setAlertColor("warning");
                    props.setMessageSnackbar(t("WorkspaceAlwaysWithWaterMarkWarning.message"));
                    props.setShowSnackBar(true);
                    setSnackSeverity("warning");
                    setSnackMesssage(t("WorkspaceAlwaysWithWaterMarkWarning.message"));
                    setIsOpenSnack(true);
                } 
                
                setShareFileConfig(shareFileNull);
            }
        })
        .catch((error) => {
            if( error.response && error.response.data && typeof error.response.data  === 'string')
            {
                props.setAlertColor("error");
                props.setMessageSnackbar(error.response.data);
                props.setShowSnackBar(true);  
                setSnackSeverity("error");
                setSnackMesssage(error.response.data);
                setIsOpenSnack(true);              
            }
            else
            {
                props.setAlertColor("error");
                props.setMessageSnackbar(error.response.data);
                props.setShowSnackBar(true);
                setSnackSeverity("error");
                setSnackMesssage(error.response.data);
                setIsOpenSnack(true);  
            }
            
        })
        .finally(()=>{
            setWaitConsult(false);
        })
    },[
        props.shareFileConfig
    ]);

    useEffect(() => {
        if(shareFileConfig != undefined)
        {
            if(shareFileConfig.dateCalendar != undefined)
            {
                let splited:string[] = shareFileConfig.dateCalendar.split('/');

                let date: Date = new Date(Number(splited[2]), Number(splited[1])-1, Number(splited[0]), 0, 0, 0, 0);
                setSelectedDate(date);
            }

             if(shareFileConfig.hasWatermark != undefined) {
                setHasWatermark(shareFileConfig.hasWatermark);
                setWatermarkOptions({
                    needWm: shareFileConfig.hasWatermark,
                    text: shareFileConfig.waterMarkMessage!,
                    orientation: "vertical"
                });
                setRadioWatermark("2");
            }
            
            if(shareFileConfig.accessTotal != undefined)
                setAcessCount(shareFileConfig.accessTotal.toString());

            if(shareFileConfig.isAlwaysAcess != undefined)
            {
                setDontExpire(shareFileConfig.isAlwaysAcess);
                if(shareFileConfig.isAlwaysAcess == true)
                {
                    setIsCalendar(false);
                    setIsAcess(false);
                }
                else
                {
                    if(shareFileConfig.isCalendar != undefined)
                        setIsCalendar(shareFileConfig.isCalendar);

                    if(shareFileConfig.isCountAcess != undefined)
                        setIsAcess(shareFileConfig.isCountAcess);
                }
            }
            else
            {
                if(shareFileConfig.isCalendar != undefined)
                    setIsCalendar(shareFileConfig.isCalendar);

                if(shareFileConfig.isCountAcess != undefined)
                    setIsAcess(shareFileConfig.isCountAcess);
            }

            if(shareFileConfig.emailList != undefined && shareFileConfig.emailList.length > 0){
                setEmails(shareFileConfig.emailList)
            }
        }
    },[
        shareFileConfig
    ]);


    useEffect(() => {
        setWaitConsult(true);
        GetOrganizationUserName(
            nameOrg!,
            ""
        )
        .then(data => {
            setUsersMenu(data?.map(user => user.login!));
        })
        .catch(err => {
            props.setAlertColor("error");
            props.setMessageSnackbar(err.response.data);
            props.setShowSnackBar(true);
            setSnackSeverity("error");
            setSnackMesssage(err.response.data);
            setIsOpenSnack(true);
        })
        .finally(() => {
            setWaitConsult(false)
        })

    }, []);

    const save = () =>
    {
        let dateString:string | undefined = undefined;
        if(selectedDate != undefined){
            let stringDay:string = selectedDate.getDate().toString();
            let stringMonth:string = (selectedDate.getMonth() + 1).toString();
            if(stringDay.length == 1)
            {
                stringDay = "0" + stringDay
            }
            if(stringMonth.length == 1)
            {
                stringMonth = "0" + stringMonth
            }

            dateString = stringDay+ "/" + stringMonth + "/" + selectedDate.getFullYear().toString()
        }

        let acessCountParsed:number = parseInt(acessCount, 10);

        if ((selectedDate ? (isCalendar && selectedDate > new Date()) : false) || acessCountParsed > 0 || dontExpire) {
            if(emails.length <= 0) {
                props.setAlertColor("warning");
                props.setMessageSnackbar(t("SharedFile.ListEmails"));
                props.setShowSnackBar(true);
                setSnackSeverity("warning");
                setSnackMesssage(t("SharedFile.ListEmails"));
                setIsOpenSnack(true);
                throw new Error();
            }               
        } 
     
        if (!isCalendar && !isAcess && !dontExpire) {
            props.setAlertColor("warning");
            props.setMessageSnackbar(t("SharedFile.NotCheckBox"));
            props.setShowSnackBar(true);
            setSnackSeverity("warning");
            setSnackMesssage(t("SharedFile.NotCheckBox"));
            setIsOpenSnack(true);
            throw new Error();
        } 
        
        setWaitSave(true);

        if(shareFileConfig != undefined && shareFileConfig.id)
        {
            let shareFile:ShareFile = {
                id:shareFileConfig.id,
                itemId:props.shareFileConfig.itemId,
                emailList:emails,
                isCalendar:isCalendar,
                isCountAcess:isAcess,
                dateCalendar:dateString,
                accessTotal:acessCountParsed,
                isAlwaysAcess:dontExpire,
                hasWatermark: hasWatermark,
                waterMarkMessage: watermarkOptions.text,
                waterMarkOrientation: watermarkOptions.orientation
            }
 
                UpdateSharedFileInformation(shareFile)
                .then((result) =>
                {
                    props.saveOkMetod();
                    setShareFileConfig(undefined);
                    props.setAlertColor("success");
                    props.setMessageSnackbar(t("ShareFileComp.shareSuccess"));
                    props.setShowSnackBar(true);
                    setSnackSeverity("success");
                    setSnackMesssage(t("SharedFile.shareSuccess"));
                    setIsOpenSnack(true);
                })
                .catch((error) => {
                    if( error.response && error.response.data && typeof error.response.data  === 'string')
                    {
                        props.setAlertColor("error");
                        props.setMessageSnackbar(error.response.data);
                        props.setShowSnackBar(true);
                        setSnackSeverity("error");
                        setSnackMesssage(error.response.data);
                        setIsOpenSnack(true);
                    }
                    else
                    {
                        props.setAlertColor("error");
                        props.setMessageSnackbar(t("SharedFile.ErroOnSave"));
                        props.setShowSnackBar(true);
                        setSnackSeverity("error");
                        setSnackMesssage(t("SharedFile.ErroOnSave"));
                        setIsOpenSnack(true);
                    }
                })
                .finally(() => {
                    setWaitSave(false);
                })
            } 
        
        else
        {
            let shareFileCreate:ShareFileCreate = {
                itemId:props.shareFileConfig.itemId,
                emailList:emails,
                isCalendar:isCalendar,
                isCountAcess:isAcess,
                dateCalendar:dateString,
                accessTotal:acessCountParsed,
                isAlwaysAcess:dontExpire,
                hasWatermark: hasWatermark,
                waterMarkMessage: watermarkOptions.text,
                waterMarkOrientation: watermarkOptions.orientation
            }

            SaveSharedFileInformation(shareFileCreate)
            .then((result) =>
            {
                props.saveOkMetod();
                props.setAlertColor("success");
                props.setMessageSnackbar(t("ShareFileComp.shareSuccess"));
                props.setShowSnackBar(true);
                setSnackSeverity("success");
                setSnackMesssage(t("ShareFileComp.shareSuccess"));
                setIsOpenSnack(true);
            })
            .catch((error) => {
                if( error.response && error.response.data && typeof error.response.data  === 'string')
                {
                    props.setAlertColor("error");
                    props.setMessageSnackbar(error.response.data);
                    props.setShowSnackBar(true);
                    setSnackSeverity("error");
                    setSnackMesssage(error.response.data);
                    setIsOpenSnack(true);
                }
                else
                {
                    props.setAlertColor("error");
                    props.setMessageSnackbar(t("SharedFile.ErroOnSave"));
                    props.setShowSnackBar(true);
                    setSnackSeverity("error");
                    setSnackMesssage(t("SharedFile.ErroOnSave"));
                    setIsOpenSnack(true);
                }
            })
            .finally(() => {
                setWaitSave(false);
            })
            
        }
    }

    function changeIsCalendar (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        if(checked == undefined || checked == false)
        {
            setIsCalendar(false);
        }
        else
        {
            setIsCalendar(true);
        }
      };

      function changeIsAcess (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        if(checked == undefined || checked == false)
        {
            setIsAcess(false);
            setAcessCount("1");
        }
        else
        {
            setIsAcess(true);
        }
    };


    function changeDontExpire (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        if(checked == undefined || checked == false)
        {
            setDontExpire(false);
        }
        else
        {
            setDontExpire(true);
            setIsCalendar(false);
            setIsAcess(false);
        }
    };

    function changehasWatermark (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        if(checked == undefined || checked == false)
        {
            setHasWatermark(false);
        }
        else
        {
            setHasWatermark(true);
        }
    };

    const handleEmailsChange = (event: any, newValue: string[]) => {
        const allValid = newValue.every(email => validateEmail(email));
        
        if (allValid)
            setEmails(newValue);
    };

    const handleClose = () => {
        setIsOpenSnack(false);
    };

    return (
        <Box sx={{ position: 'relative', minHeight: '100%', pb: '72px' }}>        
        { sharePanelState.default ? (
            <ShareFileCompDefault 
                changeDontExpire={changeDontExpire}
                changeIsAcess={changeIsAcess}
                changeIsCalendar={changeIsCalendar}
                setHasWatermark={setHasWatermark}
                dontExpire={dontExpire}
                emails={emails}
                fileExtension={fileExtension}
                fileName={fileName}
                handleEmailsChange={handleEmailsChange}
                hasWatermark={hasWatermark}
                isAcess={isAcess}
                isCalendar={isCalendar}
                setAcessCount={setAcessCount}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                setSharePanelState={setSharePanelState}
                usersMenu={usersMenu}
                waitConsult={waitConsult}
                waitSave={waitSave}
                acessCount={acessCount}
                onClose={props.onClose}
            />
        ) : (
            <ShareFileWatermark 
                handleChangeWater={handleChangeWater}
                setSharePanelState={setSharePanelState}
                setWatermarkOptions={setWatermarkOptions}
                watermark={waterMark}
                watermarkOptions={watermarkOptions}
            />
        ) }
        { sharePanelState.default && (
            <Button
                fullWidth
                startIcon={<Check sx={{ color: "#FFFFFF" }} />}
                sx={{
                    background: "#22638D 0% 0% no-repeat padding-box",
                    borderRadius: "4px",
                    opacity: 1,
                    position: "absolute",
                    bottom: 0,
                    ":hover": {
                        background: "#22638D 0% 0% no-repeat padding-box",
                        borderRadius: "4px",
                        opacity: 0.8,
                    }
                }}
                onClick={save}
            >
                <Typography
                    sx={{
                        textAlign: "left",
                        font: "normal normal normal 16px/24px Segoe UI",
                        letterSpacing: "0px",
                        color: "#FFFFFF",
                        opacity: 1,
                    }}
                    textTransform="none"
                >
                    { t("ShareFileComp.share") }    
                </Typography>
            </Button>
        )  }
         <KeydriveSnackbar 
                message={snackMessage}
                open={isOpenSnack}
                variant={snackSeverity}
                onClose={handleClose}
            />
      </Box>
    )
}

export default ShareFileComp;